// Utilities
/**
 * Ajax client for Planner Service which converts the planner error response to standard Error
 */ export class PlannerAjaxClient {
    async executeRequest(url, options) {
        try {
            return await this.innerAjaxClient.executeRequest(url, options);
        } catch (e) {
            if (e.response && !e.error) {
                const error = await this.generatePlannerError(e.response);
                if (error) {
                    e.error = error;
                }
            }
            throw e;
        }
    }
    /**
     * Handle a planner error response
     * @param response Response
     */ async generatePlannerError(response) {
        try {
            const errorResponse = await response.clone().json();
            const error = new Error(errorResponse.error?.message);
            error.name = errorResponse.error?.code;
            return error;
        } catch (e) {
            return null;
        }
    }
    /**
     * Initializes a new instance of the PlannerAjaxClient
     * @param innerAjaxClient Ajax client
     */ constructor(innerAjaxClient){
        this.innerAjaxClient = innerAjaxClient;
    }
}
